// Generat automat din README.md
import React from 'react';

const Badge = ({ 
  children, 
  variant = 'default', 
  className = '',
  size = 'md',
  pulse = false 
}) => {
  const variants = {
    default: 'badge-default',
    success: 'badge-success',
    warning: 'badge-warning',
    error: 'badge-error',
    info: 'badge-info'
  };

  const sizes = {
    sm: 'px-2 py-0.5 text-xs',
    md: 'px-3 py-1 text-xs',
    lg: 'px-4 py-1.5 text-sm'
  };

  const pulseClass = pulse ? 'animate-pulse' : '';

  return (
    <span className={`badge ${variants[variant]} ${sizes[size]} ${pulseClass} ${className}`}>
      {children}
    </span>
  );
};

export default Badge;
